/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Actions_Group_DocumentsInputs */

const vi_order_actions_group_documents = /** @type {(inputs: Order_Actions_Group_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In / Tải chứng từ`)
};

/**

* @param {Order_Actions_Group_DocumentsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_actions_group_documents = /** @type {((inputs?: Order_Actions_Group_DocumentsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Actions_Group_DocumentsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_actions_group_documents(inputs)
});